import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import PropTypes from 'prop-types';

const TooltipOverlay = (text) => (
  <Popover id="popover-trigger-parsing">
    {text}
  </Popover>
);

const Tooltip = ({ children, text, placement }) => (
  <OverlayTrigger trigger={['hover', 'focus']} placement={placement} overlay={TooltipOverlay(text)}>
    {children}
  </OverlayTrigger>
);

Tooltip.propTypes = {
  children: PropTypes.any,
  text: PropTypes.string,
  placement: PropTypes.string,
};

Tooltip.defaultProps = {
  placement: 'bottom',
};

export default Tooltip;
